import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import img from "../assets/img/auth_layout.png";
import CookiesBanner from "@/components/cookieBanner/CookiesBanner";

const AuthLayout: React.FC = () => {
  return (
    <>
      <Header />
      <div className="w-full h-[calc(100vh-64px)] lg:grid lg:grid-cols-2">
        <div className="flex items-center justify-center py-12 px-3 ">
          <Outlet />
        </div>
        <div className="hidden h-full bg-muted lg:flex items-center justify-center bg-white">
          <div
            style={{
              width: "calc(75vh)",
              height: "calc(75vh)",
              background: `url(${img})`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
            className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
          ></div>
        </div>
      </div>
      <CookiesBanner />
    </>
  );
};

export default AuthLayout;
